module.exports = new __parcel__URL__("decision.5244d9b2.png").toString();